const productSystem = ({
  1: 'vereador',
  2: 'prefeito',
  3: 'deputado',
});

const productSystemEnum = {
  VEREADOR: 1,
  PREFEITO: 2,
  DEPUTADO: 3,
};

export {
  productSystem,
  productSystemEnum,
};
